<template>
  <teleport to="body">
    <transition name="backdrop-fade">
      <div
        v-if="visible"
        class="bottom-sheet-backdrop"
        @click="handleBackdropClick"
      ></div>
    </transition>

    <transition name="slide-up">
      <div v-if="visible" class="bottom-sheet-container">
        <button
          v-if="showCloseButton"
          class="bottom-sheet-close"
          @click="handleClose"
        >
          <svg
            class="h-3 w-3"
            viewBox="0 0 14 14"
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
          >
            <path
              clip-rule="evenodd"
              d="M8.41155 7.00032L13.6886 12.2822C14.079 12.6729 14.0787 13.306 13.688 13.6964C13.2973 14.0867 12.6641 14.0864 12.2738 13.6957L6.99628 8.41348L1.70658 13.6953C1.31577 14.0856 0.682602 14.0851 0.292368 13.6943C-0.0978661 13.3035 -0.0973954 12.6703 0.293419 12.2801L5.58271 6.99863L0.29565 1.70679C-0.094698 1.31609 -0.0944116 0.682921 0.296289 0.292573C0.68699 -0.0977741 1.32016 -0.0974878 1.7105 0.293213L6.99797 5.58547L12.2739 0.317343C12.6648 -0.0728905 13.2979 -0.0724199 13.6881 0.318395C14.0784 0.709209 14.0779 1.34237 13.6871 1.73261L8.41155 7.00032Z"
            />
          </svg>
        </button>

        <div class="bottom-sheet-content">
          <slot />
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { watch } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  showCloseButton: {
    type: Boolean,
    default: true,
  },
  closeOnBackdrop: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['close', 'update:visible'])

function handleClose() {
  emit('close')
  emit('update:visible', false)
}

function handleBackdropClick() {
  if (props.closeOnBackdrop) {
    handleClose()
  }
}

// Prevent body scroll when bottom sheet is open
watch(
  () => props.visible,
  (isVisible) => {
    if (isVisible) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = ''
    }
  }
)
</script>

<style scoped>
.bottom-sheet-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9998;
}

.bottom-sheet-container {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  max-height: 85vh;
  background: var(--bg-2);
  border-radius: 24px 24px 0 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.bottom-sheet-close {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 50;
  background: transparent;
  border: none;
  color: var(--text-1);
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
}

.bottom-sheet-close:hover {
  color: var(--brand-hover);
}

.bottom-sheet-content {
  overflow-y: auto;
  max-height: 85vh;
  padding: 20px;
  padding-top: 20px;
}

/* Transitions */
.backdrop-fade-enter-active,
.backdrop-fade-leave-active {
  transition: opacity 0.3s ease;
}

.backdrop-fade-enter-from,
.backdrop-fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-leave-active {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-up-enter-from {
  transform: translateY(100%);
}

.slide-up-leave-to {
  transform: translateY(100%);
}
</style>
